import axios from 'axios';

axios.interceptors.response.use(
   (response) => {
      return response;
   },
   async (error) => {
   if (error.response) {
      if (error.response.status === 401) {
         // Do something, call refreshToken() request for example;
         // return a request
         //alert("-- 401 --");
         //
         localStorage.removeItem('userAppModule');
         localStorage.removeItem('user');
         //window.location.href = '/';
         /*
         this.$store.dispatch('auth/logout');
         this.$router.push('/login');
         */
         // return Promise.reject("Su permiso de acceso a expirado, conectese nuevamente.");
         return Promise.reject(error);
         //return axios_instance(config);
      }
      //alert("-- "+error.response+" --");
      /*
      if (error.response.status === ANOTHER_STATUS_CODE) {
         // Do something 
         return Promise.reject(error.response.data);
      }
      */
   }
   //alert("-- "+error+" --");

   return Promise.reject(error);
   }
);